<template>
  <dashboard-modal
    :modal-id="modalId"
    :title="modalTitle"
    :preloader="preloader"
    @submit="submit"
    @close-modal="closeModal"
  >
    <template slot="body">
      <app-overlay-loader v-if="preloader" />
      <form
        class="mb-0"
        :class="{ 'loading-opacity': preloader }"
        ref="form"
        :data-url="
          selectedUrl
            ? `/accreditationtechnical/evaluationobjetion/store/${inputs.id}`
            : `/accreditationtechnical/evaluationobjetion/store/`
        "
      >
        <div class="row" v-if="evaluationList && evaluationList.length > 0">
          <div class="col-12">
            <app-note
              class="pt-2 clearfix"
              :title="$t('Procesos en bloque')"
              content-type="html"
              note-type="note-warning"
              :notes="[
                $t(
                  'Al realizar o no la objeción de la propuesta de equipo evaluador se efectuará la misma acción para las siguientes evaluaciones o testificaciones'
                ),
              ]"
            />
          </div>
          <br />
          <div class="col-12">
            <table class="table table-sm table-striped">
              <thead>
                <tr>
                  <th scope="col">Expediente</th>
                  <th scope="col">Tipo</th>
                  <th scope="col">Código</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(value, key) in evaluationList" :key="key">
                  <td class="align-middle">
                    {{ value.accreditation_applications.record }}
                  </td>
                  <td class="align-middle">
                    <br />
                    <p v-if="value.type == 'E'">Evaluación</p>
                    <p v-if="value.type == 'T'">Testificación</p>
                  </td>
                  <td class="align-middle">{{ value.code }}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
        <div class="col-12" v-if="observations">
          <div class="form-group">
            <label>Objeciones OEC</label>
            <table class="table table-sm table-striped text-center">
              <thead>
                <tr>
                  <th scope="col">Observación</th>
                  <th scope="col">Fecha</th>
                  <th scope="col">Usuario</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(value, key) in observations" :key="key">
                  <td>{{ value.observation }}</td>
                  <td>{{ dateToString(value.created_at) }}</td>
                  <td>{{ value.user.full_name }}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
        <hr />
        <div class="col-sm-12" style="text-align: center">
          <h5 class="text-primary">¿Se acepta la objeción?</h5>
          <!-- <h6 class="text-danger" v-if="inputs.file">opcional</h6> -->
          <h6 class="text-danger" v-if="inputs.options == '1'">
            Al aceptar la objeción se volverá a planificar la evaluación
          </h6>
          <!-- <a
              :href="inputs.file"
              v-if="inputs.file"
              class="btn btn-success"
              target="_blank"
            >
            
              <app-icon name="file" />
            </a> -->

          <div class="row">
            <div class="col-sm-12">
              <div class="form-group">
                <label>Propuesta del equipo evaluador</label>
                <div>
                  <button
                    type="submit"
                    class="btn btn-success"
                    @click.prevent="openTab('evaluation_team_file')"
                  >
                    <app-icon name="file" />
                    {{ $t("view") }}
                  </button>
                </div>
              </div>
            </div>

            <div class="col-sm-12" v-if="inputs.file_evaluation_objetion">
              <div class="form-group">
                <label
                  >Información adicional Objeción al nombramiento del equipo
                  evaluador</label
                >
                <div>
                  <button
                    type="submit"
                    class="btn btn-success"
                    @click.prevent="openTab('file_evaluation_objetion')"
                  >
                    <app-icon name="file" />
                    {{ $t("view") }}
                  </button>
                </div>
              </div>
            </div>
          </div>
          <br /><br />
          <div class="form-group">
            <app-input
              type="radio-buttons"
              v-model="inputs.options"
              :required="true"
              :list="list"
            />
          </div>
        </div>
        <!-- </div> -->
        <div
          class="form-group row align-items-center"
          v-if="inputs.options == 0"
        >
          <label for="inputs_name" class="col-sm-3 mb-0">
            {{ $t("Observaciones") }}
          </label>
          <app-input
            id="inputs_name"
            class="col-sm-9"
            type="textarea"
            v-model="inputs.observations"
          />
        </div>
      </form>
    </template>
  </dashboard-modal>
</template>

<script>
import { FormMixin } from "@/core/mixins/form/FormMixin.js";
import { ModalMixin } from "@/app/Mixins/ModalMixin";

export default {
  name: "ApplicacionAddModal",
  mixins: [FormMixin, ModalMixin],
  props: {
    tableId: String,
    accreditationEmployeList: Array,
  },
  
  data() {
    return {
      preloader: false,
      inputs: {},

      request: {},
      observations: "",
      modalId: "objetion-add-edit-modal",
      modalTitle: this.$t("add"),
      formInstruction1: [
        this.$t("Si existen observaciones escribelas en el siguiente recuadro"),
      ],
      evaluationList:"",
      list: [
        {
          id: "0",
          value: "No",
        },
        {
          id: "1",
          value: "Si",
        },
      ],
    };
  },

  created() {
    if (this.selectedUrl) {
      this.modalTitle = this.$t("Revisión de la objeción");
      this.preloader = true;
    }
    this.evaluationObservation;
  },
  methods: {
    dateToString(date) {
      return date != null ? moment(date).format("YYYY-MM-DD") : null;
    },
    submit() {
      if(this.inputs.options == 0 && !this.inputs.observations){
        this.$toastr.e(this.$t("Es necesario agregar una observación"));
        return;
      }
      this.request["id"] = this.inputs.id;
      this.request["observation"] = this.inputs.observations;
      this.request["options"] = this.inputs.options;
      this.save(this.request);
    },
    afterSuccess(response) {
      this.$toastr.s(this.$t("updated_success"));
      this.$hub.$emit("reload-" + this.tableId);
    },

    openTab(fileName) {
      const w = window.open(this.inputs[fileName].path, "_blank");
      w.focus();
    },

    afterSuccessFromGetEditData(response) {
      this.preloader = false;
      let url = `accreditationtechnical/evaluationobjetion/observationList/${response.data.id}`;
      this.axiosGet(url).then((response) => {
        if(response.data.length > 0){
          this.observations = response.data;
        }
      });
      if (response.data.phone) this.phone = response.data.phone;
      this.inputs = response.data;
      if (response.data.file_evaluation_objetion.full_url) {
        this.inputs.file = response.data.file_evaluation_objetion.full_url;
        this.preloader = false;
      }

      if (response.data.evaluationList && response.data.evaluationList.length > 0) {
        this.evaluationList = response.data.evaluationList;
      }
      

      this.preloader = false;
    },
  },
};
</script>